import { render } from "./TeamingToolbarButton.vue?vue&type=template&id=05ad8f10&scoped=true"
import script from "./TeamingToolbarButton.vue?vue&type=script&lang=js"
export * from "./TeamingToolbarButton.vue?vue&type=script&lang=js"

import "./TeamingToolbarButton.vue?vue&type=style&index=0&id=05ad8f10&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-05ad8f10"

export default script